// extracted by mini-css-extract-plugin
export default {"root":"contentBlock_root__YU5ND","addButton":"contentBlock_addButton__91tnR","tasks":"contentBlock_tasks__AN4qb"};